import LoginModal from "./LoginModal";

export default LoginModal


// WEBPACK FOOTER //
// ./src/components/loginModal/index.ts